import NearbyItem from 'views/conversationsNearby/nearbyItem/NearbyItem.container';

export default NearbyItem;